export var CopyableConfigurationTypes;
(function (CopyableConfigurationTypes) {
    CopyableConfigurationTypes["BiasingProfile"] = "BIASING_PROFILE";
    CopyableConfigurationTypes["Rule"] = "RULE";
    CopyableConfigurationTypes["Zone"] = "ZONE";
    CopyableConfigurationTypes["Redirect"] = "REDIRECT";
    CopyableConfigurationTypes["Navigation"] = "NAVIGATION";
})(CopyableConfigurationTypes || (CopyableConfigurationTypes = {}));
